import { c as _c } from "react/compiler-runtime";
import { dateFromMintNumber, displayedEonNumberFromIndex, displayedEpochNumberFromIndex, displayedEraNumberFromIndex, displayedPeriodNumberFromIndex, displayedSeasonNumberFromIndex, displayedYearNumberFromIndex, getSeasonIndexForDate } from "@/components/meme-calendar/meme-calendar.helpers";
import clsx from "clsx";
import Link from "next/link";
const SECONDARY_PERIOD_CLASS_NAME = "tw-hidden md:tw-flex";
export default function MemeCalendarPeriods(t0) {
  const $ = _c(27);
  const {
    id,
    seasonHref,
    showOnlySeasonOnMobile: t1
  } = t0;
  const showOnlySeasonOnMobile = t1 === undefined ? false : t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== id || $[1] !== seasonHref || $[2] !== showOnlySeasonOnMobile) {
    const d = dateFromMintNumber(id);
    const idx = getSeasonIndexForDate(d);
    const eon = displayedEonNumberFromIndex(idx);
    const era = displayedEraNumberFromIndex(idx);
    const period = displayedPeriodNumberFromIndex(idx);
    const epoch = displayedEpochNumberFromIndex(idx);
    const year = displayedYearNumberFromIndex(idx);
    const szn = displayedSeasonNumberFromIndex(idx);
    const printSecondaryPeriod = _temp;
    let t11;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <span>SZN</span>;
      $[12] = t11;
    } else {
      t11 = $[12];
    }
    const seasonContent = <>{t11}<span>{szn}</span></>;
    const secondaryPeriodClassName = showOnlySeasonOnMobile ? SECONDARY_PERIOD_CLASS_NAME : undefined;
    t9 = "tw-flex tw-flex-wrap tw-items-center tw-gap-2";
    t10 = seasonHref ? <Link href={seasonHref} aria-label={`View SZN ${szn} cards`} className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 tw-no-underline tw-transition-colors hover:tw-border-primary-400 hover:tw-text-primary-300">{seasonContent}</Link> : <span className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100">{seasonContent}</span>;
    t2 = "Meme calendar position";
    if ($[13] !== secondaryPeriodClassName) {
      t3 = clsx("tw-flex-wrap tw-items-center tw-gap-1.5", secondaryPeriodClassName);
      $[13] = secondaryPeriodClassName;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t4 = printSecondaryPeriod("YEAR", year);
    t5 = printSecondaryPeriod("EPOCH", epoch);
    t6 = printSecondaryPeriod("PERIOD", period);
    t7 = printSecondaryPeriod("ERA", era);
    t8 = printSecondaryPeriod("EON", eon);
    $[0] = id;
    $[1] = seasonHref;
    $[2] = showOnlySeasonOnMobile;
    $[3] = t10;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t11 = <span aria-label={t2} className={t3}>{t4}{t5}{t6}{t7}{t8}</span>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <span className={t9}>{t10}{t11}</span>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp(label, number) {
  return <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-text-[10.5px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-iron-500"><span>{label}</span><span className="tw-font-semibold tw-text-iron-300">{number}</span></span>;
}